interface LogoProps {
  variant?: 'light' | 'dark';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function Logo({ size = 'md', variant = 'dark', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'h-16',
    md: 'h-24',
    lg: 'h-32'
  };

  const filterClasses = {
    light: 'brightness-0 invert', // Logo branco para fundos escuros
    dark: '' // Logo original para fundos claros
  };

  return (
    <div className={`${sizeClasses[size]} ${className} flex items-center`}>
      <img 
        src="https://public.readdy.ai/ai/img_res/d8616a5f-14e9-4fde-b8df-29c530baff1b.png" 
        alt="Ativo News" 
        className={`h-full w-auto object-contain ${filterClasses[variant]}`}
      />
    </div>
  );
}
